import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importation des fichiers de traduction
import translationEN from './locales/en/translate.json';
import translationFR from './locales/fr/translate.json';

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
};

i18n
  .use(LanguageDetector) // Détecte automatiquement la langue du navigateur
  .use(initReactI18next) // Lien entre i18next et React
  .init({
    resources,
    fallbackLng: 'en', // Si la langue n'est pas détectée, utilise l'anglais
    interpolation: {
      escapeValue: false, // React se charge déjà de protéger contre les XSS
    },
  });

export default i18n;